"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.first = void 0;
const utils_1 = require("../utils");
const case_check_recipe_1 = require("./case-check-recipe");
exports.first = (0, case_check_recipe_1.caseCheckRecipe)(utils_1.identity, undefined, utils_1.truth);
